export type { QuizModalProps } from "./QuizModal";
export { QuizModal } from "./QuizModal";
